import { useEffect } from 'react';

function SoundInitializer() {
  useEffect(() => {
    const unlockAudio = () => {
      if (Howler.ctx.state === 'suspended') {
        Howler.ctx.resume().then(() => console.log('Web Audio API resumed'));
      }

      document.removeEventListener('click', unlockAudio);
    };

    document.addEventListener('click', unlockAudio);

    return () => document.removeEventListener('click', unlockAudio);
  }, []);

  return null;
}

export default SoundInitializer;
